/**
 * @generated SignedSource<<58770fd368c81eee83c178411dbba30b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserGreekType = "ALPHA" | "BETA" | "DELTA" | "GAMMA";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type ManualRecordSelectPageQuery$variables = {
  end: string;
  start: string;
};
export type ManualRecordSelectPageQuery$data = {
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly calendar: {
          readonly id: string;
        };
        readonly conferenceCalls: ReadonlyArray<{
          readonly url: string;
        }>;
        readonly end: string | null;
        readonly guid: string;
        readonly id: string;
        readonly isAllDay: boolean;
        readonly recurrenceRule: ReadonlyArray<string | null> | null;
        readonly start: string | null;
        readonly title: string;
        readonly willBeRecorded: WillBeRecordedType;
      };
    } | null>;
  };
  readonly viewer: {
    readonly user: {
      readonly fullName: string;
      readonly id: string;
      readonly internalAttributes: {
        readonly greekType: UserGreekType | null;
      } | null;
    };
  };
};
export type ManualRecordSelectPageQuery = {
  response: ManualRecordSelectPageQuery$data;
  variables: ManualRecordSelectPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "greekType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "end",
      "variableName": "end"
    },
    {
      "kind": "Literal",
      "name": "expansionLimit",
      "value": 1
    },
    {
      "kind": "Literal",
      "name": "includePersonalMeetings",
      "value": false
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "start"
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAllDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recurrenceRule",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "noCache",
                  "value": true
                }
              ],
              "kind": "ScalarField",
              "name": "willBeRecorded",
              "storageKey": "willBeRecorded(noCache:true)"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ConferenceCall",
              "kind": "LinkedField",
              "name": "conferenceCalls",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "calendar",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManualRecordSelectPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ManualRecordSelectPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ]
  },
  "params": {
    "cacheID": "1c771ba639a1dc74a46e68a6c4e16ab3",
    "id": null,
    "metadata": {},
    "name": "ManualRecordSelectPageQuery",
    "operationKind": "query",
    "text": "query ManualRecordSelectPageQuery(\n  $start: DateTime!\n  $end: DateTime!\n) {\n  viewer {\n    user {\n      id\n      fullName\n      internalAttributes {\n        greekType\n        id\n      }\n    }\n    id\n  }\n  events(start: $start, end: $end, expansionLimit: 1, includePersonalMeetings: false) {\n    edges {\n      node {\n        id\n        guid\n        start\n        end\n        isAllDay\n        title\n        recurrenceRule\n        willBeRecorded(noCache: true)\n        conferenceCalls {\n          url\n        }\n        calendar {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ab3854d1f6362750b911dccde077677";

export default node;
